<script setup lang="ts">
import {computed, Ref, ref, watch} from "vue";
import {useDisplay} from "vuetify";
import {Project} from "@/types";
import axios from "axios";
import {route} from "ziggy-js";
import {router, usePage} from "@inertiajs/vue3";
import SendcryptLogo from "@/components/SendcryptLogo.vue";
import CopyLabelBtn from "@/components/buttons/CopyLabelBtn.vue";

interface Props {
    modelValue: boolean
    sealBox: string | null
}

const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

watch(value, (newValue) => {
    if (newValue) {
        step.value = 1
    }
})

const step = ref(1)

const confirm = () => {
    step.value = 2
}

const login = () => {
    const url = `sendcrypt://${props.sealBox}`
    window.open(url.toString(), '_self')
}

const closeDialog = () => {
    axios.delete(route('auth-app.delete')).then(() => {
        value.value = false
    })
}

const computedSealBox = computed(() => {
    return props.sealBox ? props.sealBox : ''
})
</script>

<template>
    <v-dialog
        v-model="value"
        max-width="500"
        overlay-opacity="0.4"
        @click:outside="closeDialog"
    >
        <v-card
            :flat="true"
            rounded="lg"
        >
            <v-card-title class="font-weight-bold border-bottom text-body-1 pt-4 border-b-sm">
                Sign in using your browser <v-icon>mdi-web</v-icon>
                <v-btn
                    variant="plain"
                    size="small"
                    icon="mdi-close"
                    class="float-end pb-2"
                    @click="closeDialog"
                />
            </v-card-title>

            <v-card-text class="pa-5 text-black text-body-2">
                <p>SendCrypt requires you to sign in using your browser to access your account.</p>
                <br>
                <p>Your browser will redirect you back to SendCrypt once you have signed in. If your browser asks for permission to open SendCrypt, please allow it.</p>
            </v-card-text>

            <v-divider />

            <v-card-actions class="px-5 py-4">
                <copy-label-btn
                    v-if="step === 2"
                    :text="computedSealBox"
                >
                    Manually enter token
                </copy-label-btn>
                <v-spacer />
                <success-btn
                    v-if="step === 1"
                    class="border"
                    rounded="lg"
                    @click="confirm"
                >
                    Continue with browser
                </success-btn>
                <success-btn
                    v-if="step === 2"
                    class="border"
                    rounded="lg"
                    @click="login"
                >
                    Launch
                </success-btn>
                <default-btn
                    @click="closeDialog"
                >
                    Cancel
                </default-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>
